import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Table } from 'semantic-ui-react';
import moment from 'moment-timezone';
import moments from 'moment';
import cm from 'helpers/commons';
import StepMenu from 'components/SettlementList/StepMenu';
import SideMenu from 'components/SettlementList/SideMenu';
import { LoadingBar } from 'components/Commons';
import * as settlementAction from 'actions/settlement';
import Constants from 'components/SettlementList/Constants';

moment.tz.setDefault('Asia/Seoul');

class SettlementDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultActiveIndex: null
    };
  }

  componentDidMount() {
    cm.propsInit(this.props);
    cm.mainTitle('정산 정보');
  }

  componentWillMount() {
    this.progressStatus();
    this.tradingInfo();
    this.taxInvoice();
    this.bankDeposit();
  }

  // 거래명세서 정보
  tradingInfo = async () => {
    const { settlementAPI } = this.props;
    const { taxUnitSeq } = this.props.match.params;

    await settlementAPI.settlementTrading(taxUnitSeq);
  };

  // 세금산서 정보
  taxInvoice = async () => {
    const { settlementAPI } = this.props;
    const { taxUnitSeq } = this.props.match.params;

    await settlementAPI.settlementTaxInvoice(taxUnitSeq);
  };

  // 은행입금 정보
  bankDeposit = async () => {
    const { settlementAPI } = this.props;
    const { taxUnitSeq } = this.props.match.params;

    await settlementAPI.settlementBankDeposit(taxUnitSeq);
  };

  // 진행상태
  progressStatus = async () => {
    const { settlementAPI } = this.props;
    const { taxUnitSeq } = this.props.match.params;

    await settlementAPI.settlementProgressStatus(taxUnitSeq).then(() => {
      const { stepProgress } = this.props;
      const { currentProgressStatus } = stepProgress.data;

      if (currentProgressStatus === Constants.PROGRESS_STATUS.TAX) {
        this.setState({ defaultActiveIndex: 1 });
      } else if (currentProgressStatus === Constants.PROGRESS_STATUS.BANK) {
        this.setState({ defaultActiveIndex: 2 });
      } else {
        this.setState({ defaultActiveIndex: 0 });
      }
    });
  };

  render() {
    const { tradingInfo } = this.props;
    const { defaultActiveIndex } = this.state;

    let loading = '';

    if (!tradingInfo) {
      loading = <LoadingBar />;
    }

    return (
      <main>
        <div className="top-btn button">
          {tradingInfo && (
            <Table basic="very" celled textAlign="right">
              <Table.Body>
                <Table.Row>
                  <Table.Cell>No.{tradingInfo.data.companyTrading.taxUnitSeq}</Table.Cell>
                  <Table.Cell>{tradingInfo.data.companyTrading.taxGroupName}</Table.Cell>
                  <Table.Cell>
                    {moments(tradingInfo.data.companyTrading.settleStartYmd).format('YYYY-MM-DD')}
                    {`  ~  `}
                    {moments(tradingInfo.data.companyTrading.settleEndYmd).format('YYYY-MM-DD')}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          )}
        </div>

        <div className="search-box si">
          <Container fluid>
            {loading}

            <div>
              <StepMenu />
              {defaultActiveIndex != null && (
                <div style={{ marginTop: '10px' }}>
                  <SideMenu subMenuData={this.props} defaultActiveIndex={defaultActiveIndex} />
                </div>
              )}
            </div>
          </Container>
        </div>
      </main>
    );
  }
}

SettlementDetail = connect(
  (state) => ({
    tradingInfo: state.settlement.tradingInfo,
    taxInvoice: state.settlement.taxInvoiceList,
    bankData: state.settlement.bankDepositDetail,
    stepProgress: state.settlement.progressStatus
  }),
  (dispatch) => ({
    settlementAPI: bindActionCreators(
      {
        settlementTrading: settlementAction.SettlementTradingInfoDetail,
        settlementMetaInfo: settlementAction.SettlementMetaInfoDetail,
        settlementTaxInvoice: settlementAction.SettlementTaxInvoice,
        settlementBankDeposit: settlementAction.SettlementBankDeposit,
        settlementProgressStatus: settlementAction.SettlementProgressStatus
      },
      dispatch
    )
  })
)(SettlementDetail);

export default SettlementDetail;
